import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/tax-settings";
const options = {role: ROLE.RESTAURANT};


// export const configureTaxSettings = async (values) => {
//   return await axiosInstance(options).post(`${path}/configure-tax-settings`, values);
// }
export const updateTaxSettings = async (values) => {
  return await axiosInstance(options).post(`${path}/update`, values);
}
export const taxSettingOptions = async (values) => {
  return await axiosInstance(options).post(`${path}/get-configure-tax-settings`, values);
}